import React, { lazy, Suspense } from 'react';
import {
  Hero,
  Stats,
  LiveRatesSection,
  PWASection
} from '../components/home';

const BlogSection = lazy(() => import('../components/blog/BlogSection').then(module => ({ default: module.BlogSection })));

export function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Stats />
      <LiveRatesSection />
      <Suspense fallback={<div className="py-20 bg-white text-center">Loading...</div>}>
        <BlogSection />
      </Suspense>
      <PWASection />
    </div>
  );
}